'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIpod = function IoIpod(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 24.3c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1-2.5 2.5-2.5z m6.5-19.3c1.2 0 2.2 0.9 2.2 2.2v25.6c0 1.3-1 2.2-2.2 2.2h-13.1c-1.2 0-2.2-0.9-2.2-2.2v-25.6c0-1.3 1-2.2 2.2-2.2h13.1z m-6.5 27.5c3.1 0 5.6-2.5 5.6-5.6s-2.5-5.6-5.6-5.6-5.7 2.5-5.7 5.6 2.5 5.6 5.7 5.6z m6.2-14.8v-9.2c-0.1-0.5-0.5-0.9-0.9-1h-10.7c-0.5 0.1-0.9 0.5-0.9 1.2v8.9c0 0.6 0.5 1.1 1.1 1.1h10.2c0.7 0 1.1-0.3 1.2-1z' })
        )
    );
};

exports.default = IoIpod;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ipod.js
// module id = 2808
// module chunks = 168707334958949